import { render } from "./platillos.vue?vue&type=template&id=52568449&scoped=true"
import script from "./platillos.vue?vue&type=script&lang=js"
export * from "./platillos.vue?vue&type=script&lang=js"

import "./platillos.vue?vue&type=style&index=0&id=52568449&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52568449"]])

export default __exports__